const allPrefixes = [
    {letter: 'd', name: 'deci', value: -1 },
    {letter: 'c', name: 'centi', value: -2 },
    {letter: 'm', name: 'mili', value: -3 },
    {letter: '\u00B5', name: 'mikro', value: -6 },
    {letter: 'n', name: 'nano', value: -9 },
    {letter: 'p', name: 'piko', value: -12 },
    {letter: 'da', name: 'deca', value: 1 },
    {letter: 'h', name: 'hecto', value: 2 },
    {letter: 'k', name: 'kilo', value: 3 },
    {letter: 'M', name: 'mega', value: 6 },
    {letter: 'G', name: 'giga', value: 9 },
    {letter: 'T', name: 'tera', value: 12 }
];

const allUnits = [
    {letter: 'm\u00B2', name: 'Newton', quantity_name: 'area'},
    {letter: 'm\u00B3', name: 'Newton', quantity_name: 'volume'},
    {letter: 'N', name: 'Newton', quantity_name: 'force'},
    {letter: 'T', name: 'Tesla', quantity_name: '...'},
    {letter: 'Pa', name: 'Pascal', quantity_name: 'Longitude'},
    {letter: 'Hz', name: 'Hertz', quantity_name: 'Longitude'},
    {letter: 'm', name: 'Meter', quantity_name: 'Longitude'},
    {letter: 'g', name: 'Gram', quantity_name: 'Longitude'},
    {letter: 'A', name: 'Amper', quantity_name: 'Longitude'},
    {letter: 'V', name: 'Volt', quantity_name: 'Longitude'}
];

// Random int numbers 0 - (max-1)
const rnd = (max) => Math.floor(Math.random() * max);
// Random int numbers 1 - max
const rnd_integer = (max) => rnd(max) + 1;
const rndPref = () => rnd(allPrefixes.length);
const rndUnit = () => rnd(allUnits.length);

/**
 * Function to generate a number by logaritmic scale.
 * Arguments:
 * numDigits - number of digits
 */
const generateNumber = (numDigits) => {
    let r1, r2;

    if (rnd(2)) {
        r1 = rnd_integer(numDigits + 2);
        r2 = rnd_integer(numDigits - 2);
        return rnd_integer(Math.pow(10, r1)) / Math.pow(10, r2);
    } else {
        r1 = rnd_integer(numDigits);
        r2 = rnd_integer(numDigits);
        return rnd_integer(Math.pow(10, r1)) / Math.pow(10, r2);
    }
}

/**
 * Function to generate a prefix from self.allPrefixes array.
 */
const generatePrefixAndUnit = () => {
    let randomPrefFrom = allPrefixes[rndPref()];
    let randomPrefTo = ((rnd) => {
        do {
            rnd = allPrefixes[rndPref()];
        } while ( rnd === randomPrefFrom);
        return rnd;
    })();
    let randomUnit = allUnits[rndUnit()];

    return { randomPrefFrom, randomPrefTo, randomUnit };
}

const generateProblem = (numDigits) => {
    let number = generateNumber(numDigits);
    let prun = generatePrefixAndUnit();

    return {number, ...prun};
}

const generateSolution = (problem) => {
    // part for exponent
    let expSolution = problem.randomPrefFrom.value - problem.randomPrefTo.value;
    if (problem.randomUnit.quantity_name === 'area') {
        expSolution *= 2;
    }
    if (problem.randomUnit.quantity_name === 'volume') {
        expSolution *= 3;
    }

    // part for standard
    let solutionStandardNum = problem.number;
    let solutionExp = expSolution;
    // Solution machine - solver
    if (problem.number >= 1) {
        while (solutionStandardNum / 10 >= 1) {
            solutionStandardNum /= 10;
            solutionExp += 1;
        }
    } else {
        do {
            solutionStandardNum *= 10;
            solutionExp -= 1;
        } while (solutionStandardNum < 1);
    }
    // Round number on 2 decimal
    solutionStandardNum = Math.round(solutionStandardNum * 100) / 100;
    let standardSolution = solutionStandardNum;
    let standardExpSolution = solutionExp;

    return {expSolution, standardSolution, standardExpSolution};
}

const data = (numDigits = 5, numOfProblems = 10) => {
    const data = [];
    for( let i = 0 ; i < numOfProblems; i++ ) {
        const problem = generateProblem(numDigits);
        const solution = generateSolution(problem);
        const solvedExp = 0;
        const solvedStand = 0;
        data.push({ ...problem, ...solution, solvedExp, solvedStand });
    }
    return data;
}

export default data;
